/* Les Intentionnelles : globe 3D léger des villes du réseau (COBE, ~6 Ko gz, local). Chargé SEULEMENT quand le bloc approche de l'écran (IntersectionObserver, marge 300 px).
   Pause hors écran et onglet caché ; mouvement réduit ou WebGL absent : image fixe (une seule image dessinée) ou rien ; glissement horizontal au doigt/souris (touch-action: pan-y garde le défilement vertical).
   Marqueurs : uniquement les six villes de la présentation officielle 2026-2027 (Paris, Bruxelles, Montréal, Québec, Dakar, Abidjan).
   Shopify : assets/mi-in-globe.js (même fichier) + assets/mi-cobe.js ; adresse du module dans data-cobe. */
(function () {
  var root = document.querySelector('[data-ir-globe]');
  if (!root) return;
  var canvas = root.querySelector('canvas');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var markers = [];
  try { markers = JSON.parse(root.getAttribute('data-markers') || '[]').map(function (m) { return { location: [m[0], m[1]], size: 0.075, color: [1, 0.2, 0.62] }; }); } catch (e) {}
  var started = false;
  function off() { root.classList.add('is-off'); }
  function start() {
    if (started) return; started = true;
    var test = document.createElement('canvas'), gl = null;
    try { gl = test.getContext('webgl') || test.getContext('experimental-webgl'); } catch (e) {}
    if (!gl) return off();
    /* import dynamique via Function : le traitement des assets Shopify réécrit la syntaxe import() en require() et la casse */
    var load; try { load = new Function('u', 'return import(u)'); } catch (e) { return off(); }
    load(new URL(root.getAttribute('data-cobe'), document.baseURI).href).then(function (mod) {
      var createGlobe = mod.default;
      var size = Math.max(200, Math.round(root.clientWidth || 300));
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = size * dpr; canvas.height = size * dpr;
      var phi = 4.9, theta = 0.22, drag = null, vel = 0, visible = true, last = performance.now(), slow = 0, frames = 0, skip = false, tick = 0;
      var globe = createGlobe(canvas, {
        devicePixelRatio: dpr, width: size, height: size, phi: phi, theta: theta,
        dark: 0, diffuse: 1.1, scale: 1, mapSamples: 16000, mapBrightness: 1.4, mapBaseBrightness: 0,
        baseColor: [1, 1, 1], markerColor: [1, 0.2, 0.62], glowColor: [1, 0.85, 0.9],
        markers: markers, markerElevation: 0.02, opacity: 1
      });
      canvas.classList.add('is-ready'); root.classList.add('is-on');
      function draw() { globe.update({ phi: phi, theta: theta }); }
      draw();
      if (reduce) return; /* image fixe : une image, aucune boucle */
      function frame(now) {
        requestAnimationFrame(frame);
        if (!visible || document.hidden) { last = now; return; }
        var dt = Math.min(now - last, 64); last = now;
        if (frames < 40) { frames++; slow += dt; if (frames === 40 && slow / 40 > 24) skip = true; } /* téléphone lent : 30 images par seconde */
        if (skip && (++tick % 2)) return;
        if (!drag) { phi += dt * 0.00025 + vel; vel *= 0.95; }
        draw();
      }
      requestAnimationFrame(frame);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(root);
      canvas.addEventListener('pointerdown', function (e) { drag = { x: e.clientX }; canvas.setPointerCapture(e.pointerId); root.classList.add('is-drag'); });
      canvas.addEventListener('pointermove', function (e) { if (!drag) return; var d = e.clientX - drag.x; drag.x = e.clientX; phi += d / size * 2.2; vel = d / size * 0.04; });
      var end = function () { drag = null; root.classList.remove('is-drag'); };
      canvas.addEventListener('pointerup', end); canvas.addEventListener('pointercancel', end);
    }).catch(function (e) { if (window.console) console.warn('globe', e); off(); });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '300px' });
    io.observe(root);
  } else start();
})();
